///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../collections/report-drawers.collection.ts"/>
///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportDrawerMoverDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected drawers: ReportDrawersCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.drawers;
        }

        constructor(model: Dictionary<any>, properties: string[], options: any) {
            super(model, properties, options);

            this.drawers = new ReportDrawersCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue || SmartMoverHiddenValue.EmptyArray,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.tips = ['TIP_NOT_SELECTING_DRAWER'];
            this.title = 'LABEL_DRAWER';
            this.allSelectedLabel = 'LABEL_ALL_DRAWERS';
            this.totalSelectedMessage = 'LABEL_TOTAL_DRAWERS_SELECTED';
            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_DRAWERS' }, this)
            ];
            this.drawers.addFilters(...this.filters as IInteractiveFilter[]);
        }
    }
}